// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1M3Ln","title":"_3bzN3","items":"_90dN7"};